// extracted by mini-css-extract-plugin
export var root = "++la";
export var rootIcon = "_6RmX";
export var rootIconFilled = "Acg4";
export var rootIconHalf = "eEvE";